export const generateLeadHTML = (leadData: any, allComments: any, dropdwonData: any,financeData: any) => {
  return `
      <div style="font-family: Arial, sans-serif; padding: 15px; width: 800px;">
          <div style="display: flex; justify-content: space-between; align-items: center;">
              <div style="flex: 1;">
                  <img src="/assets/images/fintrack_logo.png" style="height: 50px;" />
              </div>
              <div style="flex: 1; text-align: center;">
                  <h2 style="color: blue; font-weight: bold;">Lead No: ${leadData.leadID || ""}</h2>
              </div>
              <div style="flex: 1; text-align: right;">
                  <h3 style="color: black;">Date: ${new Date().toLocaleDateString()}</h3>
              </div>
          </div>
          
          <hr style="border: 2px solid blue; margin: 10px 0;">

          <table style="width: 100%; border-collapse: collapse;">
              <tr>
                  <td><strong>First Name:</strong></td>
                  <td style="border: 1px solid black; padding: 5px; min-width: 100px; font-size: 16px;">
                      ${leadData.firstName || "N/A"}
                  </td>
                  <td style="width: 20px;"></td>
                  <td><strong>Created:</strong></td>
                  <td style="border: 1px solid black; padding: 5px; font-size: 16px;">
                      ${leadData.createdOn ? new Date(leadData.createdOn).toLocaleString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                      }) : "N/A"}
                  </td>
              </tr>
              <tr>
                  <td><strong>Surname:</strong></td>
                  <td style="border: 1px solid black; padding: 5px; font-size: 16px;">${leadData.surname || "N/A"}</td>
                  <td></td>
                  <td><strong>Source:</strong></td>
                  <td style="border: 1px solid black; padding: 5px; font-size: 16px;">
                      ${dropdwonData?.leadSources?.find((item: any) => item.value == leadData.source)?.label || "N/A"}
                  </td>
              </tr>
              <tr>
                  <td><strong>Followup:</strong></td>
                  <td style="border: 1px solid black; padding: 5px; font-size: 16px;">
                      ${leadData.followUp ? new Date(leadData.followUp).toLocaleString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                      }) : "N/A"}
                  </td>
                  <td></td>
                  <td><strong>Staff:</strong></td>
                  <td style="border: 1px solid black; padding: 5px; font-size: 16px;">
                      ${dropdwonData?.staff?.find((item: any) => item.value == leadData.staff)?.label || "N/A"}
                  </td>
              </tr>
              <tr>
                <td><strong>Mobile:</strong></td>
                  <td style="border: 1px solid black; padding: 5px; font-size: 16px;">${leadData.mobile || "N/A"}</td>
                       <td></td>
                  <td><strong>Email:</strong></td>
                  <td style="border: 1px solid black; padding: 5px; font-size: 16px;">${leadData.email || "N/A"}</td>
            
              </tr>
          </table>


          <hr style="border: 2px solid blue; margin: 10px 0; margin-top: 20px;">
     

          <!-- Finance Details Section -->
   <div class="container">



<div class="row mb-3">
<!-- Tax Rate -->
<div class="col-md-6 d-flex align-items-center">
  <label class="fw-bold" style="width: 50%;">Budget Range:</label>
  <div class="form-control" style="width: 50%;">
   ${leadData.houseValue ? `$${leadData.houseValue}` : " "}
  </div>
</div>
<div class="col-md-6 d-flex align-items-center">
  <label class="fw-bold" style="width: 50%;">New OR Old:</label>
  <div class="form-control" style="width: 50%;">
    ${leadData.realEstateAgent3 || " "}
  </div>
</div>

</div>
<div class="row mb-3">
<!-- Tax Rate -->
<div class="col-md-6 d-flex align-items-center">
  <label class="fw-bold" style="width: 50%;">Finance Approved:</label>
  <div class="form-control" style="width: 50%;">
    ${leadData.taxableIncome || " "}
  </div>
</div>

<!-- Bed / Bath / Car -->
<!-- Bed / Bath / Car -->
<div class="col-md-6 d-flex align-items-center">
  <label class="fw-bold" style="width: 50%;">Titled:</label>
  <div class="form-control" style="width: 50%;">
    ${leadData.combinedSuper || " "}
  </div>
</div>
</div>
<div class="row mb-3">
<!-- Contract Type -->
<div class="col-md-6 d-flex align-items-center">
  <label class="fw-bold w-50">Contract Type:</label>
  <div class="form-control w-50">
    ${leadData.propertyPurpose || " "}
  </div>
</div>

<!-- States -->
 <div class="col-md-6 d-flex align-items-center">
  <label class="fw-bold" style="width: 50%;">Bed / Bath / Car:</label>
  <div class="form-control" style="width: 50%;">
    ${leadData.location_Beds_Baths_Cars || " "}
  </div>
</div>
</div>

<div class="row mb-3">
<!-- Strategy Type -->
<div class="col-md-6 d-flex align-items-center">
  <label class="fw-bold w-50">Strategy Type:</label>
  <div class="form-control w-50">
    ${leadData.realEstateAgent1 || " "}
  </div>
</div>

<!-- Areas -->

 <div class="col-md-6 d-flex align-items-center">
  <label class="fw-bold w-50">States:</label>
  <div class="form-control w-50">
    ${leadData.location_State_Area_Suburb || " "}
  </div>
</div> 
</div>
<div class="row mb-3">
<!-- Gearing -->
<div class="col-md-6 d-flex align-items-center">
  <label class="fw-bold w-50">Invest OR Live in:</label>
  <div class="form-control w-50">
    ${leadData.realEstateAgent2 || " "}
  </div>
</div>
<div class="col-md-6 d-flex align-items-center">
  <label class="fw-bold w-50">Areas:</label>
  <div class="form-control w-50">
    ${leadData.area || " "}
  </div>
</div>

</div>

</div>


                  <hr style="border: 2px solid blue; margin: 5px 0; margin-top: 10px;">

        
          <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
              ${allComments.map((comment: any) => {
                  const formattedDate = new Date(comment.createdOn).toLocaleString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric"
                  });
                  
                  const matchedStaff = dropdwonData?.staff?.find((s: any) => s.value == comment.staff);
                  const staffName = matchedStaff ? matchedStaff.label : "N/A";

                  return `
                      <tr>
                          <td style="padding: 2px; color: blue;">
                              <strong>Date: ${formattedDate} &nbsp;&nbsp;&nbsp; Staff Name: ${staffName}</strong>
                          </td>
                      </tr>
                      <tr>
                          <td style="padding:2px 2px 4px 2px; border-bottom: 2px solid #ddd;">
                              ${comment.commentText}
                          </td>
                      </tr>
                  `;
              }).join("") || "<tr><td>No comments available.</td></tr>"}
          </table>
      </div>
  `;
};


// <div style="display: flex; gap: 32px; align-items: flex-start; margin-bottom: 20px;">
// <!-- Left Column -->
// <div style="flex: 1;">


//     <div style="margin-bottom: 12px; display: flex; align-items: center;">
//         <label style="font-weight: 500; min-width: 90px;">State:</label>
//         <div style="background: #fff; border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px; min-width: 120px; margin-left: 8px;">
//             ${dropdwonData?.states?.find((item: any) => item.value == leadData.state)?.label || "N/A"}
//         </div>
//     </div>
//     <div style="margin-bottom: 12px; display: flex; align-items: center;">
//         <label style="font-weight: 500; min-width: 90px;">Area:</label>
//         <div style="background: #fff; border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px; min-width: 120px; margin-left: 8px;">
//             ${dropdwonData?.areas?.find((item: any) => item.value == leadData.area)?.label || "N/A"}
//         </div>
//     </div>
//     <div style="margin-bottom: 12px; display: flex; align-items: center;">
//         <label style="font-weight: 500; min-width: 90px;">Suburb:</label>
//         <div style="background: #fff; border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px; min-width: 120px; margin-left: 8px;">
//             ${dropdwonData?.suburbs?.find((item: any) => item.value == leadData.suburb)?.label || "N/A"}
//         </div>
//     </div>
//     <div style="margin-bottom: 12px; display: flex; align-items: center;">
//         <label style="font-weight: 500; min-width: 90px;">Postcode:</label>
//         <div style="background: #f3f4f6; border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px; min-width: 80px; margin-left: 8px;">
//             ${(() => {
//                 const selectedSuburb = dropdwonData?.suburbs?.find((item: any) => String(item.value) == String(leadData.suburb));
//                 return selectedSuburb && selectedSuburb.postcode ? selectedSuburb.postcode : "N/A";
//             })()}
//         </div>
//     </div>
// </div>
// <!-- Right Column -->
// <div style="flex: 1;">
//     <div style="margin-bottom: 18px;">
//         <div style="color: blue; font-weight: bold; font-size: 14px;">Real Estate Agent 1</div>
//         <div style="margin-top: 4px; background: #fff; border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px;">
//             ${(() => {
//                 const agent = dropdwonData?.realEstateAgents?.find((item: any) => item.value == leadData.realEstateAgent1);
//                 return agent ? `${agent.label}` : 'N/A';
//             })()}
//         </div>
//     </div>
//     <div style="margin-bottom: 18px;">
//         <div style="color: blue; font-weight: bold; font-size: 14px;">Real Estate Agent 2</div>
//         <div style="margin-top: 4px; background: #fff; border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px;">
//             ${(() => {
//                 const agent = dropdwonData?.realEstateAgents?.find((item: any) => item.value == leadData.realEstateAgent2);
//                 return agent ? `${agent.label}` : 'N/A';
//             })()}
//         </div>
//     </div>
//     <div style="margin-bottom: 18px;">
//         <div style="color: blue; font-weight: bold; font-size: 14px;">Real Estate Agent 3</div>
//         <div style="margin-top: 4px; background: #fff; border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px;">
//             ${(() => {
//                 const agent = dropdwonData?.realEstateAgents?.find((item: any) => item.value == leadData.realEstateAgent3);
//                 return agent ? `${agent.label}` : 'N/A';
//             })()}
//         </div>
//     </div>
// </div>
// </div>


// <h3 style="color: blue; font-weight: bold; font-size: 18px; margin: 5px;">Property</h3>

// <div style="display: flex; align-items: center; margin-bottom: 10px;">
//             <label style="font-weight: 500; min-width: 90px;">Address:</label>
//     <input type="text" readonly style="background: #fff; border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px; min-width: 550px; margin-left: 8px; font-size: 16px;" value="${leadData.propertyPurpose || 'N/A'}" />
// </div>